// extracted by mini-css-extract-plugin
export var box = "_5a-1";
export var checked = "_5a-2";
export var descriptionSpacer = "_5a-9";
export var disabled = "_5a-3";
export var icon = "_5a-6";
export var input = "_5a-0";
export var labelSpacer = "_5a-8";
export var medium = "_5a-5";
export var small = "_5a-4";
export var text = "_5a-7";